function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMixcloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3913 3353",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,60,59.9991)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2523.39,-4196.31)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,2523.39,4150.44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M768.286,786.866L910.137,786.866L910.137,11.009L629.564,11.009L473.241,750.687L436.907,750.687L280.573,11.009L0,11.009L0,786.866L141.85,786.866L141.85,139.666L116.549,47.189L161.217,47.189L325.253,786.866L585.982,786.866L748.919,47.189L794.674,47.189L768.286,139.666L768.286,786.866Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "28.8px"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixcloud);
export default __webpack_public_path__ + "static/media/Mixcloud.840f7893.svg";
export { ForwardRef as ReactComponent };